import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useState, useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import SpeacialNeeds from "./Pages/SpeacialNeeds";
import Home from "./Pages/Home";
import AboutUs from "./Pages/AboutUs";
import ErrorPage from "./Pages/404Page";
import Service from "./Pages/Service";
import SingleBlog from "./Pages/SingleBlog";
import ContactUs from "./Pages/ContactUs";
import Thanks from "./Pages/Thanks";
import Blogs from "./Pages/Blogs";
import { useTranslation } from "react-i18next";
import FloatingButtons from "./Components/FloatingButtons";

import i18n from "./i18n"; // Ensure the correct import
import useGeoInfo from "./useGeoInfo";
import ContactInfo from "./hooks/ContactInfo";

function App() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  }, [language]);

  const switchLanguage = () => {
    const newLang = language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    localStorage.setItem("lang", newLang);
  };

  //   const geo = useGeoInfo();
  //   const account = 'OnlineInstitute';
  //   const platform = 'Google';

  //   const contact = ContactInfo(account, platform);

  // console.log(contact);

  return (
    <BrowserRouter>
      <div className="font-medium text-gray text-lg leading-[27px]">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/special-needs" element={<SpeacialNeeds />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/service" element={<Service />} />
          <Route path="/single-blog" element={<SingleBlog />} />
          <Route path="/contacts" element={<ContactUs />} />
          <Route path="/thanks" element={<Thanks />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<SingleBlog />} />
          <Route path="*" element={<Home />} />
        </Routes>

        {/* <ul>
        <li><strong>IP:</strong> {geo.ip}</li>
        <li><strong>Latitude:</strong> {geo.lat}</li>
        <li><strong>Longitude:</strong> {geo.lng}</li>
        <li><strong>Country:</strong> {geo.country}</li>
        <li><strong>City:</strong> {geo.city}</li>
        <li><strong>Region:</strong> {geo.region}</li>
      </ul>


<h2>📞 Contact Info</h2>
      {contact ? (
        <ul>
          <li>WhatsApp: {contact.ext}{contact.whats_call}</li>
          <li>Phone: {contact.ext}{contact.phone_call}</li>
          <li>Email: {contact.email}</li>
          <li>Instagram: <a href={contact.Instagram}>Instagram</a></li>
          <li>Facebook: <a href={contact.facebook}>Facebook</a></li>
        </ul>
      ) : (
        <p>Loading contact info...</p>
      )} */}

        <Footer />
      </div>
      <FloatingButtons />
    </BrowserRouter>
  );
}

export default App;
